import type { ReactNode } from 'react';

export default function SectionTitle({ children }: { children: ReactNode }) {
  return (
    <div className="flex items-center gap-3">
      <h4 className="text-[11px] font-bold tracking-[0.18em] uppercase text-ink-700 whitespace-nowrap">
        {children}
      </h4>
      <div className="flex-1 h-px bg-ink-100" />
    </div>
  );
}